import * as sbc from '@tvlgiao/bc-supermarket-builder-components';
import React from 'react';
export default {
  sbc,
  React
};